<template>
  <div class="h-full overflow-hidden">
    <ul class="flex gap-x-5 items-center">
      <strong>{{ state.model?.hotelRoomType?.name }}</strong>
      <c_cell title="入住日期" :value="state.model?.checkin_date" />
    </ul>
    <div
      class="min-h-[50vh] p-2.5 rounded-md bg-gray-100 overflow-hidden flex flex-col mt-3"
    >
      <ul class="flex items-center gap-x-5">
        <c_cell title="需求" :value="state.model?.need_count" />
        <c_cell title="已配置" :value="state.model?.ready_count || '0'" />
        <c_cell
          title="已分房"
          :value="
            (state.model?.part_checkin_count || 0) +
              (state.model?.checkin_count || 0) || '0'
          "
          class="flex-1"
        />
        <el-button
          type="primary"
          icon="plus"
          size="small"
          link
          @click="state.showAdd = true"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="Download"
          @click="state.showImport = true"
          link
          class="!ml-[-10px]"
        >
          导入Excel
        </el-button>
      </ul>
      <el-input
        v-model="state.keywords"
        class="c-search-white mt-2"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoadRoom()"
        @clear="onLoadRoom()"
      >
        <template #suffix>
          <el-icon
            @click="onLoadRoom()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <div
        class="overflow-y-auto flex flex-col gap-y-2 overflow-x-hidden"
        v-if="state.room_data?.length"
      >
        <div
          v-for="room in state.room_data"
          :key="room.id"
          class="grid grid-cols-[1fr_auto] gap-x-5 mt-2"
        >
          <div class="p-4 rounded-md bg-white items-center gap-x-5 flex">
            <div
              class="grid grid-cols-[50px_80px_120px_auto] gap-x-5 items-center"
            >
              <strong>{{ room.number }}</strong>
              <c_cell title="楼层" :value="room.floor" />
              <c_cell
                title="可入住人数"
                :value="room.hotelRoomType?.guest_num"
              />
              <c_cell title="已分配人数" :value="room.checkin_num" />
            </div>
          </div>
          <el-button
            link
            type="danger"
            :disabled="state.model.add_data?.length <= 1"
            @click="onDelete(room)"
          >
            <template #icon>
              <el-icon :size="22" class="font-bold">
                <Delete />
              </el-icon>
            </template>
          </el-button>
        </div>
      </div>
      <div class="text-center" v-else>
        <el-image :src="require('@/assets/images/nodata.png')" />
      </div>
    </div>
    <el-dialog
      v-model="state.showAdd"
      title="添加房间"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showAdd = false;
        }
      "
      style="width: 70%"
    >
      <c_add
        :room_type="state.model"
        @close="
          state.showAdd = false;
          onLoad();
          onLoadRoom();
        "
      />
    </el-dialog>
    <el-dialog
      v-model="state.showImport"
      title="从Excel导入"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showImport = false;
        }
      "
      :width="500"
    >
      <c_import
        :room_type="state.model"
        @close="
          state.showImport = false;
          onLoad();
          onLoadRoom();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_hotelArrange_room_type_detail,
  meeting_hotelArrange_room_get,
  meeting_hotelArrange_room_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_add from "./Add.vue";
import c_import from "./Import.vue";

export default {
  props: {
    id: Number,
  },
  components: {
    c_add,
    c_import,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      onLoad();
      onLoadRoom();
    });

    const onLoad = () => {
      if (props.id) {
        meeting_hotelArrange_room_type_detail(props.id).then((res) => {
          if (res.status == 200) state.model = res.data?.data || {};
        });
      }
    };

    //获取房间
    const onLoadRoom = () => {
      meeting_hotelArrange_room_get({
        meeting_hotel_arrange_room_type_id: props.id,
        keywords: state.keywords,
      }).then((res) => {
        if (res.status == 200) state.room_data = res.data?.data?.list || [];
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_hotelArrange_room_delete, row.id, onLoad, {
        filed: "房间",
        name: row.number,
      });
    };
    return { state, onLoad, onLoadRoom, onDelete };
  },
};
</script>

<style lang="less" scoped></style>
